import { ReactNode } from "react";
import { QueryProvider } from "@/lib/react-query";

interface AppProvidersProps {
  children: ReactNode;
}

/**
 * AppProviders
 *
 * Central provider component that wraps the app with all necessary providers.
 * Currently includes:
 * - QueryProvider (TanStack Query)
 *
 * Add other providers here as needed (ThemeProvider, etc.)
 */
export function AppProviders({ children }: AppProvidersProps) {
  return <QueryProvider>{children}</QueryProvider>;
}
